import { render } from "./locationBanner.vue?vue&type=template&id=0d2fad50&scoped=true"
import script from "./locationBanner.vue?vue&type=script&lang=js"
export * from "./locationBanner.vue?vue&type=script&lang=js"

import "./locationBanner.vue?vue&type=style&index=0&id=0d2fad50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2fad50"]])

export default __exports__